import { AvatarGroup, Box, Icon } from '@ff-it/ui';
import { useChannel, useChannelState, useRealtimeConnection } from 'services';
import { UserAvatar } from './UserAvatar';
import { usePresenceUsers } from './PresenceUsers';

const realtimeStatusIcon: Partial<
  Record<ReturnType<typeof useRealtimeConnection>['status'], React.ComponentProps<typeof Icon>>
> = {
  connected: { icon: 'signal-stream', color: 'success500' },
  connecting: { icon: 'signal-stream', color: 'warning500' },
  reconnecting: { icon: 'signal-stream-slash', color: 'warning500' },
  disconnected: { icon: 'signal-stream-slash', color: 'error500' },
};

export function RealtimeStatus() {
  const { status } = useRealtimeConnection();
  const iconProps = realtimeStatusIcon[status];
  return (
    <Box testId="realtime-status" data-status={status}>
      {iconProps && <Icon {...iconProps} />}
    </Box>
  );
}

export function ChannelSubscribers() {
  const channel = useChannel();
  const { state } = useChannelState(channel);
  const { users, color } = usePresenceUsers();
  if (state === 'unsubscribed') {
    return null;
  }

  return (
    <Box
      background="brand25"
      borderRadius="xl"
      px="1"
      textSize="xs"
      display="flex"
      alignItems="center"
      testId="realtime-presence"
      data-state={state}
    >
      <Box mr="1">Online</Box>
      <AvatarGroup size="xxs">
        {users.map((user) => (
          <UserAvatar key={user.id} user={user} color={color(user.id)} />
        ))}
      </AvatarGroup>
    </Box>
  );
}
